module.exports = __webpack_public_path__ + "img/star.aa588348.svg";